import {getResource, updateResource} from "./common"
import {OrgBankAgreement} from "./orgBankAgreement"

export type OrgBankingSetupType = "NotSet" | "ReadyToLaunchBanking" | "Custom" | undefined

export type OrgBankingSetup = {
	type: "orgBankingSandboxSetup"
	id: string
	attributes?: {
		orgBankingSetup: OrgBankingSetupType
	}
}

export const getOrgBankingSetup = async (accessToken: string) =>
	await getResource<OrgBankingSetup>(`sandbox/org-banking-setup`, accessToken)

export const updateOrgBankingSetup = async (accessToken: string, orgBankingSetup: OrgBankingSetupType) => {
	const result = await updateResource<OrgBankAgreement>("sandbox/org-banking-setup", accessToken, {
		attributes: {
			orgBankingSetup,
		},
	})
	return result.map((v) => v.data)
}
